import { Row, Col, Card } from "reactstrap";
import styles from "./styles.module.scss";
import Link from "next/link";
import useSectors from "../../hooks/useSectors";
import useSolutions from "../../hooks/useSolutions";

const NON_LINKED_SECTORS = [
  "UI & UX",
  "Project/Program Management, Change Managment & Business Analysis",
  "Artificial Intelligence",
  "Change and Transformation",
  "Business Analysis",
  "Networking and Infrastructure",
  "Testing",
  "ERP & Customer Relationship  Management",
  "Business Analysis, Change and Transformation",
];

export const MultiColumnCTA = ({
  customClass = "",
  right_content,
  left_content,
  locale,
  leftColumnFilterUrl = `sectors/`,
  rightColumnFilterUrl = `business-solutions/`,
  sectionId = "",
}) => {
  const left_post = useSectors();
  const right_post = useSolutions();

  return (
    <section className={`${styles.root} ${customClass} py-1`} id={`${sectionId}`}>
      <Row className="m-0">
        <Col md={6} className="left-column p-md-5 p-4">
          {left_content ? (
            <div
              className="mb-4"
              dangerouslySetInnerHTML={{ __html: left_content }}
            />
          ) : null}
          {left_post?.length > 1 && (
            <div className="d-flex flex-wrap">
              {left_post?.map((post, index) => (
                <Card
                  className="bg-transparent border-0 me-2 mb-2"
                  key={index}
                >
                  {NON_LINKED_SECTORS.includes(post?.title) ? (
                    <div className="rounded-5 py-2 px-4 with-no-link">
                      {post?.title ? post.title : null}
                      <br></br>
                    </div>
                  ) : (
                    <Link
                      key={index}
                      href={`/${locale ? locale : ""}${leftColumnFilterUrl}${
                        post.url_slug
                      }/`}
                    >
                      <a className="rounded-5 py-2 px-4">
                        {post?.title ? post.title : null}
                        <br></br>
                      </a>
                    </Link>
                  )}
                </Card>
              ))}
            </div>
          )}
        </Col>
        <Col md={6} className="right-column p-md-5 p-4">
          {right_content ? (
            <div
              className="mb-4"
              dangerouslySetInnerHTML={{ __html: right_content }}
            />
          ) : null}
          {right_post?.length > 1 && (
            <div className="d-flex flex-wrap">
              {right_post?.map((post, index) => (
                <Card
                  className="bg-transparent border-0 me-2 mb-2"
                  key={index}
                >
                  <Link key={index} href={`/${rightColumnFilterUrl}`}>
                    <a className="rounded-5 py-2 px-4">{post.title}</a>
                  </Link>
                </Card>
              ))}
            </div>
          )}
        </Col>
      </Row>
    </section>
  );
};

export default MultiColumnCTA;
